import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { toast } from "@/utils/notifications";

export const LABOR_FLOWSHEET_EDIT_MISSING_ROUTE_CONTEXT_TITLE = "Cannot edit flowsheet row";
export const LABOR_FLOWSHEET_EDIT_MISSING_ROUTE_CONTEXT_MESSAGE =
  "Encounter or client context is missing. Close and reopen this row from the labor flowsheet.";

export const LABOR_FLOWSHEET_EDIT_MISSING_PREREQUISITES_MESSAGE =
  "Flowsheet edit could not be saved because the form or encounter context is incomplete. Close and reopen this row.";

export const LABOR_FLOWSHEET_EDIT_UNKNOWN_QUESTIONNAIRE_TITLE = "Cannot edit flowsheet row";
export const LABOR_FLOWSHEET_EDIT_UNKNOWN_QUESTIONNAIRE_MESSAGE =
  "This flowsheet entry type is not recognized. Close and reopen this row from the labor flowsheet, or contact support if this continues.";

interface LaborFlowsheetEditRouteContext {
  encounterId: string | undefined;
  clientId: string | undefined;
  hasRouteContext: boolean;
}

/**
 * Validates labor flowsheet edit route params and notifies when encounter/client context is missing.
 */
export function useLaborFlowsheetEditRouteContext(
  onClose?: () => void,
): LaborFlowsheetEditRouteContext {
  const { encounterId, clientId } = useParams();
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  const hasRouteContext = Boolean(encounterId && clientId);

  useEffect(() => {
    if (hasRouteContext) {
      return;
    }

    toast({
      type: "error",
      title: LABOR_FLOWSHEET_EDIT_MISSING_ROUTE_CONTEXT_TITLE,
      message: LABOR_FLOWSHEET_EDIT_MISSING_ROUTE_CONTEXT_MESSAGE,
      autoClose: false,
    });
    onCloseRef.current?.();
  }, [hasRouteContext]);

  return { encounterId, clientId, hasRouteContext };
}
